import { DateTime, Duration } from 'luxon';

export const getSmartTimeLabel = (isoDateTime?: string | null, shortText?: boolean) => {
  let label = '-';

  if (isoDateTime === null || isoDateTime === undefined) {
    // biome-ignore lint/suspicious/noConsole: reports a missing date instead of throwing
    console.error(`getSmartTimeLabel: missing isoDateTime = ${isoDateTime}`);
    return label;
  }

  const now = DateTime.local();
  const dateTime = DateTime.fromISO(isoDateTime);
  if (dateTime.isValid) {
    const duration = Duration.fromMillis(now.toMillis() - dateTime.toMillis());
    const minutes = Math.floor(duration.as('minutes'));

    if (minutes < 0) {
      label = dateTime.toLocaleString(DateTime.DATE_SHORT);
    } else if (minutes < 1) {
      label = 'now';
    } else if (minutes === 1) {
      label = shortText ? '1 min' : '1 minute';
    } else if (minutes < 60) {
      label = shortText ? `${minutes} min` : `${minutes} minutes`;
    } else {
      const hours = Math.floor(duration.as('hours'));
      if (hours === 1) {
        label = shortText ? '1 hr' : '1 hour';
      } else if (hours < 24) {
        label = shortText ? `${hours} hr` : `${hours} hours`;
      } else {
        const days = Math.floor(duration.as('days'));
        if (days === 1) {
          label = '1 day';
        } else if (days < 365) {
          label = `${days} days`;
        } else {
          label = dateTime.toLocaleString(DateTime.DATE_SHORT);
        }
      }
    }
  } else {
    // biome-ignore lint/suspicious/noConsole: reports an invalid date instead of throwing
    console.error(`getSmartTimeLabel: invalid isoDateTime = ${isoDateTime}`);
  }

  return label;
};
